import axios from 'axios'
import interceptors from './interceptors'
import env from '@/config/env'
import qs from 'qs'

const baseURL = env.apiURL
const api = axios.create({
  baseURL: `${baseURL}`,
  paramsSerializer: qs.stringify,
})

api.interceptors.request.use(interceptors.requestInterceptor)

api.interceptors.response.use(res => res, interceptors.responseOnError)

export default api
